export const setOptionsForScreeningDropdown = (surveyRef, myScreenings) => {
  try {
    const survey = surveyRef.current;
    const element = survey.getQuestionByName('qSelectScreening');
    element.choices = myScreenings.map((screen) => ({
      value: screen.id,
      text: screen.name || screen.id, // to be replaced with screen.name
      custom: {
        option: {
          id: screen.id,
          text: screen.id,
          value: screen.id,
        },
      },
    }));
    element.type = 'dropdown';
    element.visible = false;
    element.visible = true;
  } catch (e) {
    // console.error('Error setting options for screening dropdown', e);
  }
};
